import { useContext } from 'react';
import {
  ChatApiContext,
  ChatApiContextType
} from 'src/contexts/chat/chat-api-context';

export const useChatApi = () =>
  useContext(ChatApiContext) as ChatApiContextType;
